var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#E4F2F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9818 31.8334V28.7292C29.9818 25.5597 27.3929 22.9321 24.1949 22.9321H23.2933V22.6692L26.4797 22.0662V16.2654C26.4797 13.6779 24.8625 11.7405 22.3073 11.2678C21.5822 11.133 20.8585 11.133 20.1331 11.2678C17.5768 11.7406 15.9606 13.678 15.9606 16.2654V22.0662L19.1487 22.6692V22.9321H18.2459C15.0471 22.9321 12.459 25.5589 12.459 28.7292V31.8334H29.9818Z",
    fill: "#04B7B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/Female.ba88ee83d57118a281d6594545a413da.svg";
export { ForwardRef as ReactComponent };